export const casteList = [
  {
    name: 'General Category (GC)',
  },
  {
    name: 'Scheduled Caste (SC)',
  },
  {
    name: 'Scheduled Tribe (ST)',
  },
  {
    name: 'Other Backward Class (OBC)',
  },
  {
    name: 'EWS',
  },
  {
    name: 'Other',
  },
]

export const religionList = [
  {
    name: 'Hinduism',
  },
  {
    name: 'Agnostic',
  },
  {
    name: 'Atheist',
  },
  {
    name: 'Baha‘i',
  },
  {
    name: 'Buddhism',
  },
  {
    name: 'Cao Dai',
  },
  {
    name: 'christianity',
  },
  {
    name: 'Islam',
  },
  {
    name: 'Jainism',
  },
  {
    name: 'Juche',
  },
  {
    name: 'Judaism',
  },
  {
    name: 'Neo-Paganism',
  },
  {
    name: 'Non-religious',
  },
  {
    name: 'Rastafarianism',
  },
  {
    name: 'Secular',
  },
  {
    name: 'Shinto',
  },
  {
    name: 'Sikhism',
  },
  {
    name: 'Spiritism',
  },
  {
    name: 'Tenrikyo',
  },
  {
    name: 'Unitarian-Universalism',
  },
  {
    name: 'Zoroastrianism',
  },
  {
    name: 'Primal-indigenous',
  },
  {
    name: 'Chinese Traditional Religion',
  },
  {
    name: 'African Traditional & Diasporic',
  },
  {
    name: 'Other',
  },
]

export const locationList = [
  {
    name: 'Bengalore',
  },
  {
    name: 'Chennai',
  },
  {
    name: 'Mumbai',
  },
  {
    name: 'Hyderabad',
  },
  {
    name: 'New Delhi',
  },
]
